(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexlivo-connect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.nxConnectBound) return;
    window.nxConnectBound = true;

    function focusNotice() {
      var notice = document.querySelector('.nx-connect [data-nx-focus]');
      if (notice) notice.focus();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusNotice);
    } else {
      focusNotice();
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('nx-connect__form')) return;

      if (form.getAttribute('data-nx-sending') === 'true') {
        event.preventDefault();
        return;
      }
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

      form.setAttribute('data-nx-sending', 'true');
      form.setAttribute('aria-busy', 'true');

      var button = form.querySelector('[type="submit"]');
      if (button) {
        var label = button.querySelector('.nx-connect__btn-label');
        var sending = button.getAttribute('data-sending-label');
        if (label && sending) {
          button.setAttribute('data-original-label', label.textContent);
          label.textContent = sending;
        }
        button.setAttribute('aria-disabled', 'true');
      }
    });

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      document.querySelectorAll('.nx-connect__form').forEach(function (form) {
        form.removeAttribute('data-nx-sending');
        form.removeAttribute('aria-busy');
        var button = form.querySelector('[type="submit"]');
        if (!button) return;
        button.removeAttribute('aria-disabled');
        var label = button.querySelector('.nx-connect__btn-label');
        var original = button.getAttribute('data-original-label');
        if (label && original) label.textContent = original;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
